import React, { useState } from 'react';
import PropTypes from 'prop-types';
import './TextareaInput.scss';
const TextareaInput = ({ name, onChange, placeholder, value, maxLength, extraClass, errorDisplay }) => {
  
  const [dropDownErrorMsg, setDropDownErrorMsg] = useState('');
  const handleBlur = (event) => {
    if(errorDisplay) {
      const blurValue = event.target.value;
      if (value !== blurValue) {
        if (value?.trim().length > 0) {
          event.target.value = value;
        } else if (event.target.value.trim().length > 0) {
          event.target.value = '';
        }
      }
      if (event.target.value == '') {
        setDropDownErrorMsg(errorDisplay);
      } else {
        setDropDownErrorMsg('');
      }
    }
  };

  return (
    <>
      <textarea
        name={name}
        id={name}
        className={dropDownErrorMsg ? 'field-input default-textarea error-border' : (extraClass ? extraClass : 'field-input default-textarea')}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        maxLength={maxLength}
        onBlur={handleBlur}
      />
      <div>{!!dropDownErrorMsg &&
      <span  style={{ "color": "red", fontFamily: 'Roboto',fontStyle: "normal",fontWeight: 400,fontSize: "13px"}}>
        {dropDownErrorMsg}</span>}
        </div>
    </>
  );
};

TextareaInput.propTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  value: PropTypes.string,
  maxLength: PropTypes.number,
  extraClass: PropTypes.string,
};

TextareaInput.defaultProps = {
  placeholder: '',
  value: '',
  maxLength: 255,
  extraClass: '',
};

export default TextareaInput;
